import React, { useEffect } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import modalStyle from '../../../_common/core/modalStyle'
import { GuestTicketFormContainer } from '../../events/ticket/TicketGuestFormSection/GuestTicketForm'
import {
  get_event,
  get_event_addons,
  get_event_tables,
  get_event_tickets,
} from '../../../_common/core/selectors'
import { FETCH_EVENT_TABLES, FETCH_EVENT_TICKETS } from '../../../_common/redux/tickets/actions'
import {
  UPLOAD_GUESTTICKETS,
  GET_SEAT_MAP_DATA,
  GET_SEAT_MAP_STATUSES,
} from '../../../_common/redux/guesttickets/actions'
import { FETCH_EVENT_ADDONS } from '../../../_common/redux/addons/actions'
import { getGroupedTickets } from '../../utils/ticketUtils'
import { showAxiosError, showSuccessMessage } from '../../utils/messenger'
import { reserveSeatsIo } from '../../../_common/core/http_services/seatsio'
import Button from '../../_library/Button'

const GuestTicketsModal = props => {
  const {
    event,
    isModalOpen,
    closeModal,
    user,
    tickets,
    ticketTypes,
    tables,
    addons,
    seatData,
    statuses,
    seatDataChecked,
    getSeatDataLoading,
    getSeatDataStatusesLoading,
    reservation_eid,
    FETCH_EVENT_TICKETS,
    FETCH_EVENT_TABLES,
    FETCH_EVENT_ADDONS,
    GET_SEAT_MAP_DATA,
    GET_SEAT_MAP_STATUSES,
    UPLOAD_GUESTTICKETS,
    selectedSubmission,
  } = props

  useEffect(() => {
    if (event?.id) {
      try {
        FETCH_EVENT_TICKETS(event.id)
        FETCH_EVENT_TABLES(event.id)
        FETCH_EVENT_ADDONS(event.id)

        if (event.flagSeatMapAllowed) {
          if (+event.id !== +reservation_eid) {
            GET_SEAT_MAP_DATA(event.id)
            GET_SEAT_MAP_STATUSES(event.id)
          }
        }
      } catch (error) {
        showAxiosError(error)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, reservation_eid])

  const uploadGuestsFromForm = async (form, isSeatMap, isSeatsIo, seatsIoActiveId = null) => {
    if (isSeatsIo) {
      try {
        const seats = form.seat_io_tickets.map(ticket => ({
          ticketTypeId: ticket.ticketTypeId,
          label: ticket.seatsIoLabel,
        }))
        await reserveSeatsIo(event.id, seats, seatsIoActiveId ?? 'main')
        const recipients = form.seat_io_tickets.reduce((curr, item) => {
          const index = curr.findIndex(ticket => ticket.ticketTypeID === item.ticketTypeId)
          if (index !== -1) {
            curr[index].ticketHolders.push({
              first_name: item.first_name,
              last_name: item.last_name,
              add_ons: item.add_ons,
            })
            curr[index].seats_io_seats = curr[index].seats_io_seats + ',' + item.seats_io_seats
            curr[index].quantity += 1
          } else {
            curr.push({
              first_name: item.first_name,
              last_name: item.last_name,
              email: form.email,
              ticketTypeID: item.ticketTypeId,
              quantity: 1,
              ticketHolders: [
                { first_name: item.first_name, last_name: item.last_name, add_ons: item.add_ons },
              ],
              seats_io_event_id: item.seats_io_event_id,
              seats_io_seats: item.seats_io_seats,
            })
          }
          return curr
        }, [])
        await UPLOAD_GUESTTICKETS(event.id, recipients)
        showSuccessMessage('Successfully Uploaded!')
        form_helper_reset()
        return
      } catch (e) {
        showAxiosError(e)
        throw e
      }
    }
    try {
      const recipients = [
        {
          first_name: form.ticketHolders[0].first_name,
          last_name: form.ticketHolders[0].last_name,
          email: form.email,
          ticketTypeID: form.ticketTypeID || form.tableTypeID,
          tableTypeID: form.tableTypeID,
          quantity: form.quantity,
          ticketHolders: form.ticketHolders,
          notes: form.notes,
          tags: form.tags,
          reservation_id: localStorage.getItem('reservationId'),
        },
      ]
      await UPLOAD_GUESTTICKETS(event.id, recipients, isSeatMap, form.flagOverrideStock)
      showSuccessMessage('Successfully Uploaded!')
      closeModal()
      return
    } catch (e) {
      showAxiosError(e)
    }
  }

  return (
    <Modal
      className="modal-dialog modal-trans modal-lg customer-form-modal"
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      style={modalStyle}
      contentLabel="Create Custom Form"
    >
      <div className="modal-dialog modal-lg" style={{ overflow: 'visible' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h2>Issue Guest Tickets</h2>
          </div>
          <div className="modal-body">
            <div className="customer-form-guest-tickets">
              <GuestTicketFormContainer
                event={event}
                seatData={seatData}
                statuses={statuses}
                seatDataChecked={event?.flagSeatMapAllowed ? seatDataChecked : true}
                getSeatDataLoading={event?.flagSeatMapAllowed ? getSeatDataLoading : false}
                getSeatDataStatusesLoading={getSeatDataStatusesLoading}
                tickets={getGroupedTickets(tickets)}
                tables={tables}
                onSubmit={uploadGuestsFromForm}
                addons={addons}
                ticketTypes={ticketTypes}
                user={user}
                enableScrollOnError={false}
                selectedSubmission={selectedSubmission}
              />
            </div>
          </div>
          <div className="modal-footer">
            <div className="btn-toolbar btn-toolbar-right">
              <Button className="btn btn-default btn-cancel" type="button" onClick={closeModal}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

const mapStateToProps = state => {
  const event = get_event(state)
  const tickets = get_event_tickets(state)
  const tables = get_event_tables(state)
  const addons = get_event_addons(state)

  let seatData = null
  const stateEventId = state.guesttickets.eid
  const eid = event.id
  const { seatDataChecked, ticketTypes } = state.guesttickets
  const { statuses } = state.guesttickets
  const reservation_eid = state.guesttickets.eid

  if (stateEventId === eid) {
    seatData = state.guesttickets.seatData || null
  }

  return {
    user: state.auth.user,
    event,
    reservation_eid,
    tickets,
    tables,
    addons,
    seatData,
    seatDataChecked,
    getSeatDataLoading: state.loading.has('GET_SEAT_MAP_DATA'),
    statuses,
    getSeatDataStatusesLoading: state.loading.has('GET_SEAT_MAP_STATUSES'),
    ticketTypes,
  }
}

const CustomerFormGuestTicketsModal = connect(mapStateToProps, {
  FETCH_EVENT_TICKETS,
  FETCH_EVENT_TABLES,
  FETCH_EVENT_ADDONS,
  GET_SEAT_MAP_DATA,
  GET_SEAT_MAP_STATUSES,
  UPLOAD_GUESTTICKETS,
})(withRouter(GuestTicketsModal))

export default CustomerFormGuestTicketsModal
